import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adoptCloudPoints, getLinkedTag, getLocalPoints } from "../utils/rewards";

const PERKS = [
  "EARN POINTS EVERY GAME",
  "MERCH DISCOUNTS",
  "FIRST DROP ALERTS",
  "SIGNED ART & GIFTS",
  "EVENTS & MORE",
];

export function RewardsStrip() {
  const [points, setPoints] = useState(() => getLocalPoints());

  useEffect(() => {
    const onEarn = (event) => setPoints(event.detail.total);
    window.addEventListener("dolo-rewards", onEarn);
    const tag = getLinkedTag();
    if (tag) {
      adoptCloudPoints(tag).then((d) => setPoints(Math.max(getLocalPoints(), d.points || 0))).catch(() => {});
    }
    return () => window.removeEventListener("dolo-rewards", onEarn);
  }, []);

  return (
    <div className="rewards-strip" data-testid="rewards-strip">
      <div className="rewards-strip-head">
        <span className="rewards-strip-title">DOLO REWARDS</span>
        <span className="rewards-strip-tagline">PLAY THE GAMES. STACK POINTS. GET DROPS FIRST.</span>
      </div>
      <ul className="rewards-strip-perks">
        {PERKS.map((perk) => (
          <li key={perk}>{perk}</li>
        ))}
      </ul>
      <div className="rewards-strip-foot">
        <span className="rewards-strip-balance" data-testid="rewards-strip-balance">
          YOUR STASH — {points} PTS
        </span>
        <Link to="/rewards" className="rewards-strip-link" data-testid="rewards-strip-link">
          SEE THE PROGRAM →
        </Link>
      </div>
    </div>
  );
}
